export default __webpack_public_path__ + "static/media/pomodoro.a786dc9a.svg";